import React from 'react';
import styled, { css } from 'styled-components';

import { Text } from '../typography';

interface IProps extends React.HTMLProps<HTMLInputElement> {
  labels?: [string, string];
  disabled?: boolean;
  id: string;
}

export default function Switch({
  className = 'qa-switch',
  labels = ['ON', 'OFF'],
  checked = false,
  disabled = false,
  id,
  ...restProps
}: IProps) {
  const [checkedLabel, uncheckedLabel] = labels;
  return (
    <SwitchWrapper className={className} checked={checked} disabled={disabled} as="div" size="xs" weight="bold">
      <input id={id} type="checkbox" checked={checked} {...restProps} />
      <label htmlFor={id}>{checked ? checkedLabel : uncheckedLabel}</label>
    </SwitchWrapper>
  );
}

const SwitchWrapper = styled(Text)<{ checked: boolean; disabled: boolean }>`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.toggle.disabledBackgroundColour};
  border-radius: 1.6rem;
  display: inline-flex;
  height: 2.4rem;
  justify-content: space-between;
  position: relative;
  width: 5.6rem;

  ${({ checked }) =>
    checked &&
    css`
      background-color: ${({ theme }) => theme.colors.toggle.enabledBackgroundColour};
    `};
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.colors.grey450};
    `}

  & label {
    align-items: center;
    color: ${({ theme }) => theme.colors.toggle.textColour};
    display: flex;
    height: 100%;
    padding: 0 1rem;
    justify-content: flex-end;
    width: 100%;
  }

  & label:after {
    background-color: white;
    border-radius: 50%;
    content: '';
    display: block;
    height: 2rem;
    left: 0.2rem;
    pointer-events: none;
    position: absolute;
    transition: 0.25s left linear;
    width: 2rem;
  }

  & input[type='checkbox'] {
    opacity: 0;
    position: fixed;
    width: 0;
  }

  & input[type='checkbox']:checked + label {
    justify-content: flex-start;
  }

  & input[type='checkbox']:checked + label:after {
    left: 34px;
  }
`;
